import React, { useState, useEffect, useRef } from 'react';

import { Col, Row } from "react-bootstrap";

const Chart = () => {
  return (
    <div>Chart</div>
  )
}

export default Chart;